import { Endpoint } from '@square/ignition';
import { Paragraph20, TextVariants } from '@squareup/dex-ui-shared-base';
import { breakHtmlForSlashReact } from '@squareup/dex-utils-text';
import React, { FC } from 'react';

import { HttpMethodString, HttpMethods } from '../HttpMethodString';

const strings = {
  requestTitle: 'Request',
};

interface Props {
  endpoint: Endpoint | undefined;
  textVariant?: TextVariants['variant'];
}

const CodeBlockEndpointTitle: FC<Props> = ({ endpoint, textVariant }) => {
  if (!endpoint) {
    return (
      <Paragraph20 weight="semi-bold">{strings['requestTitle']}</Paragraph20>
    );
  }
  return (
    <>
      <HttpMethodString
        as="span"
        httpMethod={endpoint.httpMethod.toUpperCase() as HttpMethods}
        textVariant={textVariant}
      />
      &nbsp;
      <Paragraph20 as="span" weight="semi-bold">
        {breakHtmlForSlashReact(endpoint.path)}
      </Paragraph20>
    </>
  );
};

export { CodeBlockEndpointTitle };
